import { render, staticRenderFns } from "./fpimport.vue?vue&type=template&id=07bc95bf&scoped=true"
import script from "./fpimport.vue?vue&type=script&lang=js"
export * from "./fpimport.vue?vue&type=script&lang=js"
import style0 from "./fpimport.vue?vue&type=style&index=0&id=07bc95bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bc95bf",
  null
  
)

export default component.exports